import { assignmentsOptimizationRequest } from "./assignmentsOptimizationRequest";

export default assignmentsOptimizationRequest;
